module.exports = __webpack_public_path__ + "static/media/Thunderstorm.de3eb289.svg";